module.exports = __webpack_public_path__ + "img/teacher-pointer.a228e67c.svg";